import { render, staticRenderFns } from "./buyerLayout.vue?vue&type=template&id=fdda5432&scoped=true&"
import script from "./buyerLayout.vue?vue&type=script&lang=js&"
export * from "./buyerLayout.vue?vue&type=script&lang=js&"
import style0 from "./buyerLayout.vue?vue&type=style&index=0&id=fdda5432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdda5432",
  null
  
)

export default component.exports